import type {
  IProductSubcategory,
  IProductSubcategoryOverview,
  IProductSubcategoryParentChildObject,
} from './../types/product/models'
import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'

const apiEntityPath = '/api/productsubcategories'

export async function getProductSubcategories({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getProductSubcategories.name
  return httpGet<IProductSubcategory[]>({ callingMn, apiPath })
}

export async function getProductSubcategoryOverview(id: string) {
  const callingMn = getProductSubcategoryOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<IProductSubcategoryOverview>({ callingMn, apiPath })
}

export async function getProductGroupsForProductSubcategory(id: string) {
  const overview = await getProductSubcategoryOverview(id)
  return overview.productGroups.map((productGroup) => productGroup)
}

export async function getProductSubcategoryParentChildObject(id: string) {
  const fn = `[services/productSubcategories.ts] ${getProductSubcategoryParentChildObject.name} |`
  console.debug(`${fn} calling getProductSubcategoryOverview`)
  const overview = await getProductSubcategoryOverview(id)
  const parentChildObject: IProductSubcategoryParentChildObject = {
    parent: {
      entityName: 'productSubcategory',
      object: {
        id: overview.productSubcategory.id,
        label: overview.productSubcategory.descr,
        parent: overview.productSubcategory.productCategory, // up-link to category
      },
    },
    children: {
      entityName: 'productGroup',
      entityDataItems: overview.productGroups,
    },
  }
  return parentChildObject
}

export async function createProductSubcategory(entity: IProductSubcategory) {
  const callingMn = createProductSubcategory.name
  const apiPath = apiEntityPath
  return httpPost<IProductSubcategory>({ callingMn, apiPath, entity })
}

export async function updateProductSubcategory(
  entityData: Partial<IProductSubcategory>,
  id: TEntityId
) {
  const callingMn = updateProductSubcategory.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIProductSubcategory = Partial<IProductSubcategory>
  return httpPatchMerge<TPartialIProductSubcategory>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteProductSubcategory(
  entityData: IProductSubcategory
) {
  const callingMn = deleteProductSubcategory.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
